import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {SessionService} from './session.service';

@Injectable()
/**
 * This is base class from which all service classes are inherited and implemented.
 * Mainly for setting Authentication Tokens
 */

export class BaseService {
  // headers = new Headers({'Content-Type': 'application/json', 'Authorization': 'Token ' + AppConfig.APITOKEN});
  // options = new RequestOptions({headers: headers});
  options = {headers: new HttpHeaders().set('Authorization', 'Token ' + SessionService.apiToken)};

  constructor(protected http: HttpClient) {
  }

  updateToken() {
    this.options = {headers: new HttpHeaders().set('Authorization', 'Token ' + SessionService.apiToken)};
  }
}



// WEBPACK FOOTER //
// C:/Users/Pujaalaxmi.K/Documents/PAA-Angular version 2/src/app/services/base.service.ts